import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProductInfoComponent } from './product-info/product-info.component';

@NgModule({
  imports: [CommonModule, TranslateModule.forChild()],
  declarations: [ProductInfoComponent],
  exports: [ProductInfoComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductInfoModule {}
